export const columns = [
  {
    accessorKey: "Spec",
    header: "Spec",
    enableColumnActions: false,
    size: 100,
  },
  {
    accessorKey: "Components",
    header: "Components",
    enableColumnActions: false,
    size: 100,
  },
  {
    accessorKey: "Size",
    header: "Size",
    enableColumnActions: false,
    size: 100,
  },
  {
    accessorKey: "Dimensional Standard",
    header: "Dimensional Standard",
    enableColumnActions: false,
    size: 100,
  },
  {
    accessorKey: "Schedule/Rating",
    header: "Schedule/Rating",
    enableColumnActions: false,
    size: 100,
  },
  {
    accessorKey: "Ends",
    header: "Ends",
    enableColumnActions: false,
    size: 100,
  },
  {
    accessorKey: "Material",
    header: "Material",
    enableColumnActions: false,
    size: 100,
  },
  {
    accessorKey: "Additional Notes",
    header: "Additional Notes",
    // muiEditTextFieldProps: { type: "number" },
    enableColumnActions: false,
    size: 100,
  },
  {
    accessorKey: "Rev",
    header: "Rev",
    muiEditTextFieldProps: { type: "number" },
    enableColumnActions: false,
    size: 100,
  },
];
